<template>
    <div id="notice">
        <Header />
            <div class="container">
                <div class="menu_left_box">
                    <Noticenav :selectedType="NavSelecteType" />
                </div>
                <div class="notice_box">
                    <div class="title">
                        <h1>공지사항</h1>
                    </div>
                    <div class="accordion np_tab" role="tablist">
                        <b-card class="head">
                            <b-row>
                            <b-col>제목</b-col>
                            <b-col>날짜</b-col>
                            </b-row>
                        </b-card>
                        <b-card no-body class="mb-1" v-for="(item, index) in noticeList" :key="index">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle="'accordion-' + index" variant="info">
                                    <b-row>
                                        <b-col>[공지] {{item.title}} </b-col>
                                        <b-col>{{item.createDate.toString().substring(0,10)}}</b-col>
                                        <b-col><img src="../assets/images/icon_down_arrow.svg" alt="화살표"></b-col>
                                    </b-row>
                                </b-button>
                            </b-card-header>
                            <b-collapse :id="'accordion-'+index" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text v-html="item.message"></b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                    <!-- <b-pagination :total-rows="rows" :per-page="perPage" limit="10" class="np_page"></b-pagination> -->
                    <div class="paging" v-if="totalRecordSize > 0">
                        <a @click="prevPage()"><img src="../assets/images/arrow_left.svg" /></a>
                        <a class="current" v-if="pageList.length <= 0">1</a>
                        <a v-for="(item, index) in pageList" :key="index" :class="{'current' : item === currentPageNo}" @click="movePage(item)">{{item}}</a>
                        <a @click="nextPage()"><img src="../assets/images/arrow_right.svg" /></a>
                    </div>
                </div>
            </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Noticenav from '../components/Noticenav.vue'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
            Noticenav,
    },
    data() {
        return {
            NavSelecteType: 'Notice',
            // rows: 10,
            // perPage: 1,

            noticeList: [],

            currentPageNo: 1,      //현재 페이지 번호
            currentPageSize: 10,    //한번에 불러올 게시물 수
            maxPageCount:10,        //한 화면에 보여질 페이지 수

            listCount: 0,
            pageCount: 0,
            pageNo: 0,
            pageSize: 0,
            totalRecordSize: 0,

            pageList:[]
        }
    },
    created(){
        this.getNotice();
    },
    methods:{
        prevPage(){
            if(this.currentPageNo > 1){
                this.currentPageNo--;
                this.getNotice();
            }
        },
        nextPage(){
            if(this.currentPageNo < this.pageCount){
                this.currentPageNo++;
                this.getNotice();
            }
        },
        movePage(no){
            if(this.currentPageNo === no)
                return;

            this.currentPageNo = no;
            this.getNotice();
        },
        changePage(){
            this.pageList = [];
            if(this.pageCount === 0)
                return;

            var tmpPageNo = this.currentPageNo - 2;
            if(this.currentPageNo + 2 > this.pageCount){
                tmpPageNo--;
            }
            if(this.currentPageNo +1 > this.pageCount){
                tmpPageNo--;
            }
            for(var i=0; i<5 && tmpPageNo <= this.pageCount; ){
                if(tmpPageNo >= 1){
                    this.pageList.push(tmpPageNo);
                    i++;
                }
                tmpPageNo++;   
            }
        },
        getNotice(){
            var param = 
            {
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket
            }
            this.$Axios.post(`${this.host}/newNotice/list`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.noticeList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
    }
}

</script>